import { Helmet } from "react-helmet-async";
 import  {ClasSummaryListViewReport}  from "../../../sections/company/report/classSummary/index.js";

export default function ClassSummaryListViewReportPage(){
    return (
        <>
            <Helmet>
                <title>Class Summary Report Page</title>
            </Helmet>
            <ClasSummaryListViewReport />
        </>
    )
}